
$(() => {
    
    _toggle_password();
    _password_checker();
    
    $('#login-form').on('submit', function(){
        $(this).find(':input[type=submit]').prop('disabled', true);
    })

    $('#forgot-password').off().on('click', function(){

        let sendLabel = '<i class="fa-regular fa-envelope"></i></i>&nbsp; Send Email';
        let html = `<form method="POST" action="./forgot-password-send" id="forgot-password-send-form">
                        <div class="col-lg-12">
                            <label><i class="fa fa-solid fa-lock text-color-primary fs-1"></i></label>
                        </div>
                        <div class="col-lg-12">
                            <label class="text-color-primary fs-4">Trouble Logging In?</label>
                        </div>
                        <div class="col-lg-12 mt-2">
                            <label>Forgot your password? No worries. Just enter the email you used to sign up and we\'ll send you a link to reset it.</label>
                        </div>
                        <div class="col-lg-12 mt-4">
                            <input name="swal_email" class="form-control" placeholder="Email Address">
                        </div>
                        <div class="col-lg-12 mt-2 d-flex justify-content-center overflow-hidden" id="catcha-content">
                            
                        </div>
                        <div class="col-lg-12 row m-0 mt-2">
                            <button class="btn btn-color-secondary" id="swal_send">${sendLabel}</button>
                        </div>
                        <div class="col-lg-12 row m-0 mt-1">
                            <button class="btn btn-light" id="swal_cancel"><i class="fa fa-arrow-left"></i>&nbsp; Back to Login</button>
                        </div>
                </form>`;

        Swal.fire({
            title: '',
            html: html,
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false,
            width: '400px',
            didOpen: function() {
                grecaptcha.render($("#catcha-content")[0], {
                    'sitekey' : $(".g-recaptcha").attr('data-sitekey')
                });

                $("#swal_send").off().on('click', function(){
                    $(this).prop('disabled', true)
                    $(this).html('<i class="fa fa-spinner fa-spin"></i> Please wait...');

                    const   fData = new FormData($("#forgot-password-send-form")[0]);
                            fData.append('email_address', $('[name=swal_email]').val());
                    const   fDataFinal = _formDataToJSON(fData);

                    _method('/forgot-password-send', 'POST', false, fDataFinal).then((response) => {
                        
                        $(this).prop('disabled', false)
                        $(this).html(sendLabel);

                        if (response.response.success) {
                            _showMessage("info", response.response.outMessage);
                            
                            return false;
                        }

                        Swal.showValidationMessage(response.response.outMessage)

                    }).catch(error => {
                        $(this).prop('disabled', false)
                        $(this).html(sendLabel);
                    }); 
                });

                $("#swal_cancel").off().on('click', function(){
                    Swal.fire({showConfirmButton: false}).close();
                });
                
            }
        })
    })


    $('#inquiry').off().on('click', function(){
        _showLoading()
        _method('/get-user-inquiry', 'GET', false, '').then((response) => {
            _hideLoading();             
            if (response.response.success) {
               
                let html = `<form id="inquiry-user-detail-form">
                            <div class="col-lg-12 text-start row m-0 g-2 bg-light">
                                <div class="col-lg-12 mb-2">
                                    <label class="fs-5 fw-bold text-color-primary">Send us a message</label>
                                </div>`;
                                $.each(response.response.data.inquiry_user_detail, function(keys, values) {
                                    html += `
                                    <div class="col-lg-6 p-1 mx-auto">
                                    <div class="col-lg-12 border rounded bg-white p-2 text-center h-100">
                                        <label class="fw-bold">Contact Information <br>for <span class="text-color-primary">${values.typedesc}</span> Inquiry</label>
                                        <br>
                                        <br>
                                        <i class="fa-solid fa-location-dot text-color-primary"></i><br> ${values.address}
                                        <br>
                                        <br>
                                        <i class="fa-solid fa-address-book text-color-primary"></i><br> ${values.contact}
                                        <br>
                                        <br>
                                        <i class="fa-solid fa-envelope text-color-primary"></i><br> ${values.email}
                                    </div>
                                    </div>
                                    `;
                                });
                    html += `<div class="col-lg-12 p-2 rounded-2 row m-0 mt-2">
                                    <div class="col-lg-12 mb-2">
                                        <label class="me-2">Inquiry for <span class="required-field">*</span></label>`;
                                        $.each(response.response.data.inquiry_user_detail, function(keys, values) {
                                            html += `
                                                    <input id="inquiry_user_detail_type_${values.type}" name="inquiry_user_detail_type" type="radio" value="${values.type}">
                                                    <label for="inquiry_user_detail_type_${values.type}" class="me-2 fw-bold">${values.typedesc}</label>
                                                    `;
                                        });
                        html += `   </div>
                                    <div class="col-lg-4">
                                        <label>First Name <span class="required-field">*</span></label>
                                        <input type="text" class="form-control" name="inquiry_user_detail_fname">
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Middle Name</label>
                                        <input type="text" class="form-control" name="inquiry_user_detail_mname">
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Last Name <span class="required-field">*</span></label>
                                        <input type="text" class="form-control" name="inquiry_user_detail_lname">
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Email Address <span class="required-field">*</span></label>
                                        <input type="text" class="form-control" name="inquiry_user_detail_email">
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Contact No. <span class="required-field">*</span></label>
                                        <input type="text" class="form-control" name="inquiry_user_detail_contact">
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Company</label>
                                        <input type="text" class="form-control" name="inquiry_user_detail_company">
                                    </div>
                                    <div class="col-lg-12">
                                        <label>Message/Comment <span class="required-field">*</span></label>
                                        <textarea rows="3" class="form-control" name="inquiry_user_detail_message"></textarea>
                                    </div>
                                </div>
                            </div>
                        </form>`;
                        
                let footer = `<div class="col-lg-12 text-end">
                                 <button class="btn btn-color-secondary mx-1" id="inquiry_user_send">Send</button>
                                 <button class="btn btn-light mx-1" id="inquiry_user_cancel">Cancel</button>
                            </div>`;

                Swal.fire({
                    title: '',
                    html: html,
                    footer: footer,
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    width: '800px',
                    didOpen: function() {
                        
                        $("#inquiry_user_send").off().on('click', function(){
                            
                            $(this).prop('disabled', true)
                            $(this).html('<i class="fa fa-spinner fa-spin"></i> Please wait...');

                            _formGetDataNotIsset("inquiry-user-detail-form");

                            const   fData = new FormData($("#inquiry-user-detail-form")[0]);
                            const   fDataFinal = _formDataToJSON(fData);

                            _method('/save-user-inquiry', 'POST', false, fDataFinal).then((response) => {
                       
                                $(this).prop('disabled', false)
                                $(this).html('Send');

                                if(response.response.success){
                                  
                                    _showMessage('success', response.response.outMessage) 
                                    return false;
                                }   
                                
                                Swal.showValidationMessage(response.response.outMessage)

                            }).catch(error => { 
                            
                                $(this).prop('disabled', false)
                                $(this).html('Send');
                            }); 
                        });

                        $("#inquiry_user_cancel").off().on('click', function(){
                            Swal.fire({showConfirmButton: false}).close();
                        });
                        
                    }
                })

                return false;
            }

            _showMessage('warning', response.response.outMessage) 

        }).catch(error => {
        });
    })
    
    
})